<template>
	<div class="content-wapper">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<!--<el-breadcrumb-item :to="{ path: '' }">质量提升综合服务</el-breadcrumb-item>-->
					<el-breadcrumb-item>威知讲堂与海外信息发布</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row class="bottom-content">
			<el-col :span="6" class="left-col">
				<div v-for="data1 in menuDataList" class="menu-box">
					<el-row style="height: 4rem;line-height: 4rem;">
						<div class="menu_div">
						<el-col :span="24" style="color: #FFFFFF;font-size: 1.125rem" >
							<span>{{data1.title}}</span>
						</el-col></div>
					</el-row>
					<el-row v-for="(item,itemindex) in data1.menuList" :key="itemindex">
						<el-collapse v-model="activeName" accordion v-if="item.isCollapse">
							<el-collapse-item :title="item.title" :name="item.active">
								<el-row>
									<el-col :span="12" style="cursor: pointer;" v-for="menu in item.menus">
										<span @click="menuFun(menu.code,menu.index)"
											:class="activeClass == menu.index ? 'active-class':''">
											{{menu.name}}
										</span>
									</el-col>
								</el-row>
							</el-collapse-item>
						</el-collapse>
						<div v-else class="menu"  @click="openNewPage(item.url)">
							<span >{{item.title}}</span>
						</div>
					</el-row>
				</div>
			</el-col>
			<el-col :span="18" class="right-box">
        <!-- 培训公告-->
				<el-row class="right-box-row" style="min-height: 430px;" v-if="isPxggShow==1">
					<el-table v-loading="loading" :data="list" :show-header="false" tooltip-effect="light">
						<el-table-column align="left" :show-overflow-tooltip="true" prop="pxggTitle" class-name="pxggTitle">
							<template slot-scope="scope">
								<i class="el-icon-menu" style="margin-right: 0.625rem;"></i>
								<el-link :underline="false" @click="openPage(scope.row)">{{ scope.row.pxggTitle }}
								</el-link>
							</template>
						</el-table-column>
						<el-table-column label="日期" align="center" prop="pxggFbtime" :width="170" >
							<template slot-scope="scope">
								<span>{{ parseTime(scope.row.pxggFbtime, '{y}-{m}-{d}') }}</span>
							</template>
						</el-table-column>
					</el-table>
					<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
						:limit.sync="queryParams.pageSize" @pagination="getList" />
				</el-row>
        <!-- 培训资料-->
				<el-row class="right-box-row" style="min-height: 430px;" v-if="isPxggShow==2" v-loading.fullscreen.lock="pxzlLoading">
					<el-row class="right-box-content" v-for="data in pxzlList">
						<el-col :span="24">
							<el-row >
								<el-col :span="12" v-for="item in data">
									<el-row>
										<el-col :span="9" class="right-box-content-img" >
											<div class="image-div">
												<img :src="getImgUrl(item.imgPath)" />
												<div class="image-mask" @click="openVedioDetail(item)">
													<img src="@/assets/images/pxfw/2.png" style="width: 3.125rem;height: 3.125rem;" />
												</div>
											</div>
										</el-col>
										<el-col :span="15" class="right-box-content-right">
											<el-row class="right-box-title">
												{{item.title}}
											</el-row>
											<el-row class="right-box-title2">
												<el-col :span="12">
													讲师：{{item.teacher}}
												</el-col>
												<el-col :span="12">
													时长：{{item.duration}}
												</el-col>
											</el-row>
											<el-row class="right-box-title3">
												<el-col :span="10">
													<i class="el-icon-date"></i>
													<span>{{ parseTime(item.fbtime, '{y}-{m}-{d}') }}</span>
												</el-col>
												<el-col :span="14" v-if="item.vedioPath ==''||item.vedioPath ==null || item.vedioPath ==undefined">
													<span style="color: #a95812">此课程仅提供课件下载</span>
												</el-col>
											</el-row>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
					<pagination v-show="pxzlTotal>0" :total="pxzlTotal" :page.sync="pxzlQueryParams.pageNum"
						:limit.sync="pxzlQueryParams.pageSize" @pagination="getPxzlList" />
				</el-row>
        <!-- 海外信息发布-->
        <el-row class="right-box-row" style="min-height: 430px;" v-if="isPxggShow==3" v-loading.fullscreen.lock="pxzlLoading">
          <el-table :data="hwxxfbList" :show-header="false" tooltip-effect="light">
            <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title">
              <template slot-scope="scope">
                <i class="el-icon-menu" style="margin-right: 0.625rem;"></i>
                <el-link :underline="false" @click="openHwxxfbPage(scope.row)">{{ scope.row.title }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="日期" align="center" prop="fbTime" :width="170" >
              <template slot-scope="scope">
                <span>{{ parseTime(scope.row.fbTime, '{y}-{m}-{d}') }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="hwxxfbTotal>0" :total="hwxxfbTotal" :page.sync="queryParams.pageNum"
                      :limit.sync="queryParams.pageSize" @pagination="getHwxxfbList" />
        </el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import {updatePvNum} from "@/api/itempv/pv";
	import {
	  listPxgg,
	} from "@/api/zlts/ycjygypx/pxgg/pxgg";
	import {
	  listPxzl,
	} from "@/api/zlts/ycjygypx/pxzl/pxzl";
  import {
    listHwxxfb,getHwxxfb
  } from "@/api/zscq/hwxxfb";
	export default {
		name: 'pxfw',
		data() {
			return {
				activeName: '0',
				activeClass: 1,
				menuTitle: undefined,
				menuCode: 'zscq-pxgg',
				isPxggShow: 1,
				menuDataList: [{
						title: '知识产权',
						menuList: [{
								title: '威知讲堂',
								isCollapse: true,
								active: 1,
								menus: [{
										name: '培训公告',
										code: 'zscq-pxgg',
										index: 1
									},
									{
										name: '培训资料',
										code: 'zscq-pxzl',
										index: 2
									}
								]
							},
							// {
							// 	title: '在线公益课堂',
							// 	isCollapse: false,
							// 	code: 'zxgykt',
							// 	url: 'https://cnipa.chinakenet.com/'
							// },
							// {
							// 	title: '线上公益培训',
							// 	isCollapse: false,
							// 	code: 'xsgypx',
							// 	url: 'https://ykt.zzbjrz.com/index'
							// },
              {
                title: '海外信息发布',
                isCollapse: false,
                code: 'hwxxfb',
                url: 'hwxxfb'
              },
						]
					},
					// {
					// 	title: '质量提升',
					// 	menuList: [{
					// 		title: '培训服务',
					// 		isCollapse: true,
					// 		active: 2,
					// 		menus: [{
					// 				name: '培训公告',
					// 				code: 'zlts-pxgg',
					// 				index: 3
					// 			},
					// 			{
					// 				name: '培训资料',
					// 				code: 'zlts-pxzl',
					// 				index: 4
					// 			}
					// 		]
					// 	}]
					// },
					// {
					// 	title: '小微企业成长',
					// 	menuList: [{
					// 		title: '培训服务',
					// 		isCollapse: true,
					// 		active: 3,
					// 		menus: [{
					// 				name: '培训公告',
					// 				code: 'xwqy-pxgg',
					// 				index: 5
					// 			},
					// 			{
					// 				name: '培训资料',
					// 				code: 'xwqy-pxzl',
					// 				index: 6
					// 			}
					// 		]
					// 	}]
					// }
				],
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					pxggType:'0'
				},
				pxzlLoading: false,
				pxzlTotal: 0,
				pxzlList: [],
				pxzlQueryParams: {
					pageNum: 1,
					pageSize: 10
				},
				imgactive:undefined,
        hwxxfbList:[],
        hwxxfbTotal:0,
			}
		},
		created() {
      if(null != this.$route.query.code || undefined != this.$route.query.code){
        let code = this.$route.query.code;
        this.activeClass = 0;
        this.openNewPage(code);
      }else{
        this.activeClass = 1;
        this.getList();
      }
		},
		methods: {
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			getList() {
				this.loading = true;
				listPxgg(this.queryParams).then(response => {
				  this.list = response.rows;
				  for (let i = 0; i < this.list.length; i++) {
				    this.list[i].pxggContent = this.replaceImgSrc(this.list[i].pxggContent)
				  }
				  this.total = response.total;
				  this.loading = false;
				});
			},
			getPxzlList() {
				// console.log("pxzlList==>",this.pxzlList);
				this.pxzlLoading = true;
				listPxzl(this.pxzlQueryParams).then(response => {
				  this.pxzlList = response.rows;
				  // console.log("this.pxzlList==>",this.pxzlList);
				  this.pxzlTotal = response.total;
				  this.pxzlLoading = false;
				});
			},
      getHwxxfbList(){//海外信息发布 查询list
        this.pxzlLoading = true;
        listHwxxfb(this.queryParams).then(res=>{
          this.hwxxfbList = res.rows;
          // console.log(this.hwxxfbList)
          this.hwxxfbTotal = res.total;
          this.pxzlLoading = false;
        });
      },
			openNewPage(pageurl) {
        if(pageurl != 'hwxxfb'){
          this.utils.windowOpen(pageurl);
        }else{
          this.isPxggShow = 3;
          this.getHwxxfbList();
        }

			},
			menuFun(code, index) {
				// console.log("code==>", code, "  index==>", index);
				this.activeClass = index;
				this.menuCode = code;
				if (code.indexOf("zscq") != -1) {
					this.queryParams.pxggType = '0';
					this.pxzlQueryParams.pxzlType = '0';
				} else if (code.indexOf("zlts") != -1) {
					this.queryParams.pxggType = '1';
					this.pxzlQueryParams.pxzlType = '1';
				} else if (code.indexOf("xwqy") != -1) {
					this.queryParams.pxggType = '2';
					this.pxzlQueryParams.pxzlType = '2';
				}
				if (code.indexOf("pxgg") != -1) {
					this.isPxggShow = 1;
					this.getList();
				} else {
					this.isPxggShow = 2;
					this.getPxzlList();
				}
			},
			openDetail(item) {
				// console.log("this.menuCode", this.menuCode);
				this.$router.push({
					path: '/main/zltszhfw/pxfw/detail/' + this.menuCode + '/' + item.recid
				})
				this.$store.commit('SET_MAININDEX', '/main/zltszhfw/pxfw');
			},
			openPage(item) {
				localStorage.setItem("pxfwDetail",JSON.stringify(item));
        updatePvNum("zscq_wzjtpxgg").then(response => {
          //pv 点击培训公告
        });
				this.utils.windowOpen('/main/zltszhfw/pxfw/detail');
			},
      openHwxxfbPage(item) {
        localStorage.setItem("hwxxfbDetail",JSON.stringify(item));
        updatePvNum("zscq_hwxxfb").then(response => {
          //pv 点击海外信息发布
        });

        this.utils.windowOpen('/main/zltszhfw/pxfw/hwxxfbDetail');
      },
			openVedioDetail(item){
				localStorage.setItem("vedioDetail",JSON.stringify(item));
        updatePvNum("zscq_wzjtpxzl").then(response => {
          //pv 点击培训资料
        });
				this.utils.windowOpen('/main/zltszhfw/pxfw/vedioDetail');
			}
		}
	}
</script>

<style scoped="scoped">
	.content-wapper {
		padding: 10px;
	}

	.navigation {
		padding: 15px;
		line-height: 10px;
		height: 40px;
		background-color: #f5f5f5;
	}

	.bottom-content {
		margin-top: 0.9375rem;
	}

	.active-class {
		color: #ff0000;
	}

	.menu-box {
		background-color: #FAFAFA;
		padding: 10px;
	}

	/deep/.el-menu {
		text-align: left;
		background-color: #FAFAFA;
		border: 0;
	}

	.el-menu-item {
		margin-bottom: 10px;
		background-color: #EAEAEA;
	}

	.menu-box /deep/ .el-menu-item.is-active {
		background-color: #EBEFF8;
	}

	/deep/ .el-collapse-item__header {
		background-color: #EAEAEA;
		margin: 0.625rem 0;
		padding-left: 1.25rem;
	}

	.right-box {
		padding-left: 10px;
	}

	.right-box-row {
		border: 1px solid #cccccc;
		padding: 10px 15px 0;
	}
	.right-box-content{
		border-bottom: 1px dashed #cccccc;
		padding: 0.9375rem 0;
	}
	.right-box-content-right{
		text-align: left;
		padding-left: 1rem;
	}
	.right-box-title{
		font-size: 1.0625rem;
		font-weight: 600;
		line-height: 1.5rem;
	}
	.right-box-content-img{
		border: 1px solid #cccccc;
	}
	.right-box-title2{
		line-height: 2.1875rem;
	}
	.right-box-title3{
		line-height: 2.1875rem;
	}
	.el-icon-date{
		margin-right: 0.3125rem;
	}

	.image-div {
		width: 10.625rem;
		height: 7rem;
		position: relative;
	}
	.image-div img {
		width: 10.625rem;
		height: 7rem;
	}
	.image-mask {
		position: absolute;
		width: 100%;
		height: 100%;
		bottom: 0;
		background: rgba(101, 101, 101, 0.6);
		color: #ffffff;
		opacity: 0;
		line-height: 9.5rem;
	}
	.image-div:hover .image-mask {
		opacity: 1;
		cursor: pointer;
	}
	.menu{
		height: 3.0625rem;
		line-height: 3.0625rem;
		background-color: #eaeaea;
		margin-bottom: 0.625rem;
		text-align: left;
		padding-left: 1.25rem;
		font-size: 0.8125rem;
		cursor: pointer;

	}
	.menu:hover{
		color: #409EFF;
	}
	/deep/ .el-collapse-item__content{
		padding: 0.9375rem;
	}
	.menu_div{
		background-image: url("../../../../assets/images/pxfw/item_menu_bg.png");
		width: 300px;
		height: 60px;
	}
</style>
